import { CommercialClient, CommercialClientBranch } from "../models/CommercialClient";
import api from "./api";

export const getCommercialClients = async (params?: {
  search?: string;
  status?: string;
  responsible?: string;
}): Promise<CommercialClient[]> => {
  const response = await api.get("/api/commercialClient", { params });
  return response.data ?? [];
};

export const getCommercialClient = async (id: string): Promise<CommercialClient> => {
  const response = await api.get(`/api/commercialClient/${id}`);
  return response.data;
};

export const saveCommercialClient = async (client: CommercialClient) =>
  api.post("/api/commercialClient", client);

export const updateCommercialClient = async (client: CommercialClient) =>
  api.put(`/api/commercialClient/${client.id}`, client);

export const updateCommercialClientStatus = async (id: string, status: string) =>
  api.put(`/api/commercialClient/${id}/status`, status, {
    headers: { "Content-Type": "application/json" },
  });

export const addCommercialClientComment = async (id: string, text: string) =>
  api.post(`/api/commercialClient/${id}/comments`, { text });

export const deleteCommercialClient = async (id: string) =>
  api.delete(`/api/commercialClient/${id}`);

/** Filiais (ST/DIFAL/redução) do cliente para o simulador; não exige a tela Comercial. */
export const getClientBranches = async (companyId: string): Promise<CommercialClientBranch[]> =>
  (await api.get("/api/commercialClient/branches", { params: { companyId } })).data;
